import { useMutation } from '@apollo/client/react'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import Spinner from '~/components/Spinner'
import { GQL_LOGOUT } from '~/gql/auth/auth'
import { currentOrgSlug } from '~/helpers/apollo'
import { useAuth } from '~/helpers/store/auth'

function Logout() {
  const { t } = useTranslation()
  const { clearAuth } = useAuth()
  const [logoutGql] = useMutation(GQL_LOGOUT)
  // StrictMode rejoue l'effet en dev : une seule mutation logout suffit.
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true

    const run = async () => {
      // On attend la revocation cote API avant de partir : une redirection
      // immediate annulerait la requete et laisserait la session serveur active.
      // Une erreur reseau ne doit pas pour autant retenir l'utilisateur.
      try {
        await logoutGql()
      } catch {
        // ignore : la sortie cote client se fait quand meme
      }

      clearAuth()
      // Preserve l'organisation courante (#95) : rediriger vers `/` perdrait le
      // prefixe `/o/:slug` et retomberait sur `/o/default` (et sur `/o/_system`
      // pour le SuperAdmin). On revient donc a la racine de l'org courante.
      window.location.href = `/o/${currentOrgSlug()}`
    }

    void run()
  }, [clearAuth, logoutGql])

  return (
    <div className="w-screen h-dvh bg-background flex flex-col justify-center items-center gap-4">
      <Spinner className="size-8 text-muted-foreground" label={t('logout.pending')} />
      <p aria-hidden className="font-bold font-primary text-foreground">
        {t('logout.pending')}
      </p>
    </div>
  )
}

export default Logout
